module.exports = __webpack_public_path__ + "static/media/licenta4.5c720cb7.png";